export default __webpack_public_path__ + "images/4a0c391a88eb960fe9096393388715dd.png";